import { render } from "./TabComponent.vue?vue&type=template&id=422b4fba"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__